export default "__VITE_ASSET__DFWbiyfe__"